module.exports = __webpack_public_path__ + "img/rip-invited.18116437.svg";